import maskInput from "vanilla-text-mask/dist/vanillaTextMask";

const initBirthdayDatePicker = (oInput) => {
  const arDateMask = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];

  maskInput({
    inputElement: oInput,
    mask: arDateMask,
    guide: true,
    placeholderChar: '_',
  });

  oInput.addEventListener('input', validateDate);
  oInput.addEventListener('blur', validateDate);
};

const validateDate = (oInput) => {
  oInput = oInput.target || oInput;
  const sValue = oInput.value;
  const oCurDate = new Date();
  const iMaxDateYear = oCurDate.getFullYear();
  const iMaxDateMonth = oCurDate.getMonth();
  const iMaxDateDay = oCurDate.getDate();
  const oMaxDate = new Date(iMaxDateYear, iMaxDateMonth, iMaxDateDay);

  oMaxDate.setHours(23, 59, 59, 999);

  oInput.classList.remove('error');

  if (sValue.length === 0) {
    return true;
  }

  if (sValue.length !== 10 || sValue.includes('_')) {
    return false;
  }

  const arParts = sValue.split('.');
  const iDay = parseInt(arParts[0], 10);
  const iMonth = parseInt(arParts[1], 10) - 1;
  const iYear = parseInt(arParts[2], 10);

  const oTestDate = new Date(iYear, iMonth, iDay);

  const isDateReal = (
    oTestDate.getFullYear() === iYear &&
    oTestDate.getMonth() === iMonth &&
    oTestDate.getDate() === iDay
  );

  if (!isDateReal) {
    oInput.classList.add('error');
    return false;
  }

  if (oTestDate > oMaxDate) {
    oInput.classList.add('error');
    return false;
  }

  if (iYear < 1900) {
    oInput.classList.add('error');
    return false;
  }

  return true;
};

window.validateDate = validateDate;
window.initBirthdayDatePicker = initBirthdayDatePicker;

document.addEventListener('DOMContentLoaded', () => {
  const birthday = '#profile-birthday';
  const birthdayInput = document.querySelector(birthday);

  if (birthdayInput) {
    initBirthdayDatePicker(birthdayInput);
  }

  const phoneMask = ['+', '7', ' ', '(', /[9]/, /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
  const phoneInput1 = document.getElementById('profile-phone');
  const phoneInput2 = document.getElementById('subscribe-phone');

  const phoneInputs = [phoneInput1, phoneInput2];

  phoneInputs.forEach(phoneInput => {
    if (phoneInput) {
      maskInput({
        inputElement: phoneInput,
        mask: phoneMask
      })
    }
  })
})